import enGenerationForm from "@generation/form/src/Locales/en";
import nlGenerationForm from "@generation/form/src/Locales/nl";
import { en as enShared } from "@klantondersteuning/shared/src/locales/src/en";
import { nl as nlShared } from "@klantondersteuning/shared/src/locales/src/nl";
import { Language, Translator, genericEN, genericNL, setCurrentLanguage } from "@shared/locales";

import { en } from "./en";
import { aanvraagVozdEn } from "./forms/AanvraagVozdEn";
import { aanvraagVozdNl } from "./forms/AanvraagVozdNl";
import { overlijdenMeldenEn } from "./forms/overlijdenMeldenEn";
import { overlijdenMeldenNl } from "./forms/overlijdenMeldenNl";
import { wijzigenAdresgegevensEn } from "./forms/wijzigenAdresgegevensEn";
import { adresgegevensWijzigenNl } from "./forms/wijzigenAdresgegevensNl";
import { nl } from "./nl";

const translator = new Translator();
translator.registerTranslations(Language.Nederlands, genericNL);
translator.registerTranslations(Language.Nederlands, nlShared);
translator.registerTranslations(Language.Nederlands, nl);
translator.registerTranslations(Language.Nederlands, adresgegevensWijzigenNl);
translator.registerTranslations(Language.Nederlands, aanvraagVozdNl);
translator.registerTranslations(Language.Nederlands, overlijdenMeldenNl);
translator.registerTranslations(Language.Nederlands, nlGenerationForm);
translator.registerTranslations(Language.English, genericEN);
translator.registerTranslations(Language.English, enShared);
translator.registerTranslations(Language.English, en);
translator.registerTranslations(Language.English, wijzigenAdresgegevensEn);
translator.registerTranslations(Language.English, aanvraagVozdEn);
translator.registerTranslations(Language.English, overlijdenMeldenEn);
translator.registerTranslations(Language.English, enGenerationForm);

let currentLanguage = Language.Nederlands;
setCurrentLanguage(currentLanguage);

export const setLanguage = (language: string) => {
  currentLanguage = language === "en" ? Language.English : Language.Nederlands;
  setCurrentLanguage(currentLanguage);
};

export const translate = (key: string, properties: { [key: string]: string } = {}): string => {
  return translator.translate(key, properties);
};
